
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';
import logo from '../../assets/img/logo-header.png';
import Perfil from '../../assets/icons/perfil.png';

export default function Header() {

  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");


  const getAgendamentoLink = () => {
    if (!token) return "/Login";
    if (role === "ROLE_ADMIN") return "/Gerenciamento";
    if (role === "ROLE_USER") return "/Agendamentos";
    return "/NotFound";
  };

  const toggleMenu = () => setMenuOpen(!menuOpen);

    const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    navigate('/');
  };

  return (
    <header className="Header">
      <div className="Header-container">

        <div className="Header-logo" onClick={() => navigate('/')}>
          <img src={logo} alt="Logotipo" />
        </div>

        <div
          className={`Header-menu-toggle ${menuOpen ? "active" : ""}`}
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        <nav className={`Header-nav-links ${menuOpen ? "open" : ""}`}>

          <div className="Header-menu-item destaque">
            <Link to="/" onClick={() => setMenuOpen(false)}>Página Inicial</Link>
          </div>

          <div className="Header-menu-item">
            <Link to="/QuemSomos" onClick={() => setMenuOpen(false)}>Quem Somos</Link>
          </div>

          <div className="Header-menu-item">
            <Link to="/Produtos" onClick={() => setMenuOpen(false)}>Produtos</Link>
          </div>

          <div className="Header-menu-item">
            <Link to="/Servicos" onClick={() => setMenuOpen(false)}>Serviços</Link>
          </div>

          <div className="Header-menu-item">
            <Link to={getAgendamentoLink()} onClick={() => setMenuOpen(false)}>
              Agendamentos
            </Link>
          </div>


          {/* MOBILE ITEMS */}
          <div className="Header-menu-item mobile-account">
            <Link
              to={token ? "/Perfil" : "/Login"}
              onClick={() => setMenuOpen(false)}
            >
              Perfil
            </Link>
          </div>

          <div className="Header-menu-item mobile-account">
            <span
              onClick={() => {
                setMenuOpen(false);
                token ? handleLogout() : navigate('/Login');
              }}
            >
              {token ? "Logout" : "Login"}
            </span>
          </div>
        </nav>

        {/* PERFIL DESKTOP */}
        <div className="Header-right-menu">
          <ul>
            <li>
              <img src={Perfil} alt="Perfil" />
              <ul>
                <li>
                  <Link to={token ? "/Perfil" : "/Login"}>Perfil</Link>
                </li>
                <li>
                  <span onClick={token ? handleLogout : () => navigate('/Login')}>
                  {token ? "Logout" : "Login"}
                  </span>
                </li>
              </ul>
            </li>
          </ul>
        </div>


      </div>
    </header>
  );
}
